import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import {computed} from 'vue';
import {SelectSearch,} from '@/components/business/crud/interface/SearchType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";



export default /*#__PURE__*/_defineComponent({
  __name: 'SelectSearch',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;
const multi = props.widget.options.length > 2;

const data = ScForm.useFormData();

const value = computed<string | string[] | undefined>({
  get() {
    if (multi) {
      if (data.value[props.propName]?.$in instanceof Array) {
        return data.value[props.propName].$in;
      } else {
        return [];
      }
    } else {
      return data.value[props.propName]?.$eq;
    }
  },
  set(value) {
    if (multi) {
      if (!data.value[props.propName]) {
        data.value[props.propName] = {}
      }
      if (value instanceof Array && value.length > 0) {
        data.value[props.propName].$in = value
      } else {
        data.value[props.propName].$in = undefined
      }
    } else {
      data.value[props.propName] = value
    }
  }
})



return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    allowClear: true,
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    disabled: _ctx.info.status === 'show',
    style: {"width":"100%"},
    mode:  multi ? 'multiple' : undefined,
    placeholder: _ctx.info.title + '等于'
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.widget.options, (option) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          value: option.value,
          key: option.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.name), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "disabled", "mode", "placeholder"]))
}
}

})